import { render, staticRenderFns } from "./SignInPage.vue?vue&type=template&id=57d15b0a"
import script from "./SignInPage.vue?vue&type=script&lang=ts"
export * from "./SignInPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports